import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, 	HttpRequest, 	
  HttpHeaders, HttpInterceptor, HttpContextToken, HTTP_INTERCEPTORS, HttpContext } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';  
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MessagesService } from './messages.service';

export const BYPASS_JW_TOKEN = new HttpContextToken(() => false);

export function byPassJwToken() {
  return new HttpContext().set(BYPASS_JW_TOKEN, true);
}

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  delay = (ms: number) => new Promise(res => setTimeout(res, ms));

  constructor(private _router: Router, private messagesService:MessagesService) { }
  
  getHeaders(request : HttpRequest<any>) {
    let headers : Record<string, string> = {
      "Content-Type": "application/json",
    }

    // if (request.context.get(BYPASS_JW_TOKEN)) {
    //   let sessionData = JSON.parse(sessionStorage.getItem('sessionData') || '{}');
	  //   let empresa= sessionData.data.user_info.flags.empresa;
    //   let apiKey = sessionData.data.user_info.flags.apikey;          
    //   headers["DW-API-KEY"]= apiKey;
    //   // headers["Access-Control-Allow-Headers"]= "*";
    //   headers["X-TENANT"]= btoa(JSON.stringify({"tenantid": empresa}));
    // }
    return headers;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {  
    
    if (request.context.get(BYPASS_JW_TOKEN)) {
      let headers = new HttpHeaders(this.getHeaders(request));
			request = request.clone({ headers }); 			
    } 

    return next.handle(request).pipe(
      tap((event:any) => {
        if (event?.body?.token && event?.body?.token == 'vencido') {
          setTimeout(() => {
            this.messagesService.tokenVencido('Debes volver a iniciar sesión','Has estado inactivo por varios minutos');
          }, 500);
          localStorage.removeItem('token');
          this._router.navigate(['/login']);
        } else if (event?.body?.token) {
          localStorage.setItem('token', event?.body?.token);
        }
      })
    );
  }  
}

export const InterceptorProvider = { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true };
